import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef } from 'react';
import { jsx } from '@emotion/react';
import '../contexts/internal/StickyContext.js';
import { EditorContextProvider } from '../contexts/internal/EditorContext.js';
import { EditorInfoContextProvider } from '../contexts/external/EditorInfoContext.js';
import { EditorComponentsProvider } from '../contexts/EditorComponentsProvider.js';
import { renderNode } from '../utils/renderNode.js';
import 'qs';
import 'query-string';
import { defaultComponents } from './defaultComponents.js';

function Viewer(_ref) {
  var _components;
  var document = _ref.document,
    components = _ref.components,
    disableDefaultComponents = _ref.disableDefaultComponents,
    _ref$disableComponent = _ref.disableComponentIds,
    disableComponentIds = _ref$disableComponent === void 0 ? [] : _ref$disableComponent,
    displayDate = _ref.displayDate,
    editorInfoContext = _ref.editorInfoContext,
    unitContext = _ref.unitContext;
  var cacheRef = useRef({});
  var filteredDefaultComponents = React__default.useMemo(function () {
    disableComponentIds.forEach(function (id) {
      delete defaultComponents[id];
    });
    return defaultComponents;
  }, [disableComponentIds]);
  var documentComponents = (_components = _objectSpread2(_objectSpread2({}, disableDefaultComponents ? {} : filteredDefaultComponents), components)) !== null && _components !== void 0 ? _components : {};
  return jsx(EditorContextProvider, {
    value: document,
    newValue: document,
    editorType: "viewer",
    components: documentComponents,
    displayDate: displayDate
  }, jsx(EditorInfoContextProvider, {
    value: editorInfoContext
  }, jsx(EditorComponentsProvider, {
    contexts: unitContext
  }, renderNode(document, documentComponents, [], cacheRef.current))));
}

export { Viewer };
//# sourceMappingURL=Viewer.js.map
